import React from 'react';

/**
 * TableSkeleton Component
 * Displays animated skeleton rows for table loading states
 * @param {number} rows - Number of skeleton rows (default: 5)
 * @param {number} columns - Number of columns (default: 9)
 */
export default function TableSkeleton({ rows = 5, columns = 9 }) {
  return (
    <div className="animate-pulse">
      {/* Header skeleton */}
      <div className="bg-gray-50 h-12 flex border-b border-gray-200">
        {Array(columns).fill(0).map((_, i) => (
          <div key={i} className="flex-1 px-4 py-3 flex items-center">
            <div className="h-3 bg-gray-200 rounded w-16"></div>
          </div>
        ))}
      </div>
      {/* Row skeletons */}
      {Array(rows).fill(0).map((_, rowIdx) => (
        <div key={rowIdx} className="border-b border-gray-200 h-16 flex items-center bg-white">
          {Array(columns).fill(0).map((_, colIdx) => (
            <div key={colIdx} className="flex-1 px-4">
              <div
                className="h-4 bg-gray-200 rounded"
                style={{ width: `${60 + Math.random() * 30}%` }}
              ></div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
